<template>
  <div>
    <div class="footer__up">
      <router-link
        v-if="isLogoVisible"
        :to="homeRoute"
        class="footer__logo w-inline-block"
        style="text-decoration: none;"
      >
        <div style="display: flex; flex-direction: row; align-items: center;">
          <img
            :src="isGeneralSite ? '/logo_general.png' : '/images/logo-fisoko.svg'"
            alt=""
            :class="{
              'footer__logo-img': !isGeneralSite,
              'footer__logo-img-general': !!isGeneralSite,
            }"
          >
          <span v-if="isGeneralSite" class="footer__logo-title">
            ФЕДЕРАЛЬНАЯ СЛУЖБА ПО НАДЗОРУ В СФЕРЕ ОБРАЗОВАНИЯ И НАУКИ
          </span>
        </div>
      </router-link>

      <!--
      <div class="footer__link-container">
        <div class="footer__link-box mod--margin">
          <div class="text-xs-up mod--grey">
            <template>Техническая поддержка "Мониторинг ДО":</template>
          </div>
          <div class="text-md-bold">
            <template>helpfisoko@fioco.ru</template>
          </div>
        </div>
        <div class="footer__link-box">
          <div class="text-xs-up mod--grey">
            <template>Техническая поддержка ВПР:</template>
          </div>
          <div class="text-md-bold">
            <template>need@vprhelp.ru</template>
          </div>
        </div>
      </div>
      -->
    </div>

    <div class="footer__bottom">
      <div class="footer__bottom-copyright">
        <div class="text-md mod--grey">
          <span>{{ copyrights }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SiteDetectionMixin from '@/helpers/siteDetectionMixin'
import { HOME_ROUTES } from '@/views/Home/utils'

export default {
  name: 'LKFooter',
  mixins: [SiteDetectionMixin],
  data: () => ({
    year: new Date().getFullYear(),
    version: '0622.01',
    homeRoute: { name: HOME_ROUTES.INDEX },
  }),
  computed: {
    copyrights() {
      const text = ['©', this.serviceName, `v${this.version},`]
      if (!this.isSoop) text.push('2006 — ')
      text.push(this.year.toString(), this.who)

      return text.filter(Boolean).join(' ')
    },
    isLogoVisible() {
      return !this.isNiko && !this.isMed && !this.isSod && !this.isSoop
    },
    serviceName() {
      if (this.isLogoVisible) {
        return 'ФИС ОКО'
      }
      if (this.isSoop) {
        return 'СООП'
      }
      return ''
    },
    who() {
      if (this.isSod) {
        return ''
      }
      if (this.isSoop) {
        return 'ФИОКО'
      }
      return 'Рособрнадзор'
    },
  },
}
</script>
